var map = {
	"./avatar0.svg": 142229,
	"./avatar1.svg": 116596,
	"./avatar2.svg": 388103,
	"./avatar3.svg": 200982,
	"./avatar4.svg": 276217,
	"./avatar5.svg": 68296,
	"./avatar6.svg": 949659,
	"./avatar7.svg": 31818,
	"./avatar8.svg": 752669,
	"./avatar9.svg": 798396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204904;